package com.vamvisions.main.api.portfolio

import kotlinx.serialization.Serializable

/** A markdown document, such as a privacy policy, in one language. [updatedAt] is an ISO-8601 date. */
@Serializable
data class DocumentDto(
    val slug: String,
    val lang: String,
    val title: String,
    val markdown: String,
    val updatedAt: String,
)
